import React from "react";
import Typography from "@material-ui/core/Typography";
const SalesOrder = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Sales Order
      </Typography>
      <Typography paragraph variant="h5">
        Create the sales document based on order from customer
      </Typography>
      <Typography paragraph variant="body1">
        Sales Order is one of the features under the Sales module to perform
        sales transactions particularly to handle customer orders as an
        indication that the order is ready to be processed and fulfilled by the
        company. It contains any information regarding the customer address &
        contact, currency & exchange rate used for the transaction, applied
        terms & conditions, form printout, and the sales items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Sales Order list.
        It is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Order ID</b>
        <br />
        Indicates the ID of the Sales Order.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Name</b>
        <br />
        Indicates the name of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Order Date</b>
        <br />
        Indicates the order date of the Sales Order.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Goods Issue Status</b>
        <br />
        Indicates the goods issue status of the Sales Order. There are 3
        statuses: Unissued, Partially Issued, and Fully Issued.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Invoice Status</b>
        <br />
        Indicates the invoice status of the Sales Order. There are 3 statuses:
        Unbilled, Partially Billed, and Fully Billed.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Grand Total</b>
        <br />
        Indicates the grand total of the Sales Order.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Sales Order data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Sales Order</b>
        <br />
        This button only appears if the Goods Issue status is 'Unissued', the
        Invoice status is 'Unbilled', and the approval indicator is not
        'Document Waiting For Approval'. It is used to edit the Sales Order
        data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Order Detail</b>
        <br />
        This button is used to navigate to the Sales Order detail which contains
        some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Sales Order data.
          </li>
          <li>
            <b>Goods Issued</b> : This tab is to display any Goods Issued
            related to the Sales Order.
          </li>
          <li>
            <b>Sales Return</b> : This tab is to display any Sales Return
            related to the Sales Order.
          </li>
          <li>
            <b>A/R Invoices</b> : This tab is to display any A/R Invoices
            related to the Sales Order.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Sales Order.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the Sales
            Order.
          </li>
          <li>
            <b>PrintOut</b> : This tab is to display any PrintOut related to the
            Sales Order.
          </li>
        </ul>
        When opening the Sales Order detail, there will be 1 button appearing on
        the top section. The button is 'Edit Sales Order' which is used to edit
        the Sales Order data. The button only appears when the Goods Issue
        status is 'Unissued', the Invoice status is 'Unbilled', and the approval
        indicator is not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Sales Order</b>
        <br />
        This button only appears if the Goods Issue status is 'Unissued', the
        Invoice status is 'Unbilled', and the approval indicator is not
        'Document Waiting For Approval'. It is used to delete the Sales Order
        data. The Sales Order data is undeletable once it has relations with
        other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Sales Order document could have an approval flow if it is
        configured. The approval indicator appears as an icon after the document
        ID. There are 4 approval indicators: Document No Need Approval, Document
        Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default SalesOrder;
